import React, { useState, useEffect } from "react";

import useInterval from "@rooks/use-interval";
// import axios from "axios";
import axios from "../../../api/axios";
import AtidimSvgComponent from "./AtidimSvgComponent";
import AtidimChartComponent from "./AtidimChartComponent";
import GougeComponent from "../../GougeComponent";
import AtidimPieChart from "./AtidimPieChart";
import AtidimMap from "./AtidimMap";

// import InfoBox from "../../InfoBox";
// import GreenArrowUp from "../../../images/GreenArrowUp";
// import RedArrowDown from "../../../images/RedArrowDown";

var request_updateTimelineData_safe = true;
var request_updateTotalWeekAgo_safe = true;

function numberOfObjsArea(target, arr) {
  let count = 0;
  let devices = Array.from(target.devices).map((device) => {
    return device.deviceId;
  });
  for (let j = 0; j < devices.length; j++) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].deviceId === devices[j]) {
        count++;
      }
    }
  }
  return count;
}

function numOfObjs(id, arr) {
  let count = 0;

  if (arr === undefined) return 0;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].deviceId === id) {
      count++;
    }
  }
  return count;
}
function getDeviceId(areas, device_id) {
  return Array.from(areas)
    .map((area) => {
      let cb = [];
      area = Array.from(area.devices)
        .filter((device) => {
          return device.deviceId === device_id;
        })
        .flat();
      cb.push(area);
      return cb.flat();
    })
    .flat();
}

function getLocalHour(date) {
  if (date) {
    let hour = new Date(date).getHours();
    return hour < 10 ? `0${hour}:00` : `${hour}:00`;
  }
}
function checkIfXSecPass(timestamp, x) {
  const currentTime = new Date();
  let plusTenSec = new Date(timestamp).setSeconds(
    new Date(timestamp).getSeconds() + x
  );
  // console.log(currentTime.getTime() >= new Date(plusTenSec).getTime());

  return currentTime.getTime() >= new Date(plusTenSec).getTime();
}
function calcPercent(weekAgo, today) {
  if (today === 0 || weekAgo === 0) {
    return ["N/A", "gray"];
  } else {
    if (today > weekAgo) {
      let percentTotal = ((weekAgo / today - 1) * 100).toFixed(1);
      return [Math.abs(percentTotal), "green"];
    } else {
      let percentTotal = ((today / weekAgo - 1) * 100).toFixed(1);
      return [Math.abs(percentTotal), "red"];
    }
  }
}

function findHourData(timeline, hour, device) {
  for (let i = 0; i < timeline.length; i++) {
    if (timeline[i]["hour"] === hour && timeline[i]["deviceId"] === device) {
      return { success: 1, timeline: timeline[i] };
    }
  }
  return { success: -1, hour, timeline: timeline[0] };
}

function margeSameHours(timeline) {
  let temp = [];
  let map = new Map();
  for (let i = 0; i < timeline.length; i++) {
    let currentChecker = timeline[i];
    let deviceId = currentChecker["deviceId"];
    let currentHour;
    if (map.size === 0) {
      currentHour = parseInt(currentChecker["hour"].split(":")[0]);
      let set = new Set();
      set.add(currentHour);
      map.set(deviceId, set);
      for (let j = i + 1; j < timeline.length; j++) {
        let hour = parseInt(timeline[j]["hour"].split(":")[0]);
        if (currentHour === hour && deviceId === timeline[j]["deviceId"]) {
          let keys = currentChecker["keys"];
          currentChecker[keys[0]] =
            currentChecker[keys[0]] + timeline[j][keys[0]];
          currentChecker[keys[1]] =
            currentChecker[keys[1]] + timeline[j][keys[1]];
          currentChecker["total"] =
            currentChecker["total"] + timeline[j]["total"];
          map.set(currentHour, currentChecker);
        }
      }
      temp.push(currentChecker);
    } else {
      let hour = parseInt(currentChecker["hour"].split(":")[0]);
      let deviceId = timeline[i]["deviceId"];
      if (!map.has(deviceId)) {
        currentHour = hour;
        let set = new Set();
        set.add(currentHour);
        map.set(deviceId, set);
        for (let j = i + 1; j < timeline.length; j++) {
          let hour = parseInt(timeline[j]["hour"].split(":")[0]);
          if (currentHour === hour && deviceId === timeline[j]["deviceId"]) {
            let keys = currentChecker["keys"];
            currentChecker[keys[0]] =
              currentChecker[keys[0]] + timeline[j][keys[0]];
            currentChecker[keys[1]] =
              currentChecker[keys[1]] + timeline[j][keys[1]];
            currentChecker["total"] =
              currentChecker["total"] + timeline[j]["total"];
            map.set(currentHour, currentChecker);
          }
        }
        temp.push(currentChecker);
      } else {
        let checkHour = map.get(deviceId);
        if (!checkHour.has(hour)) {
          currentHour = hour;
          checkHour.add(currentHour);
          map.set(deviceId, checkHour);
          for (let j = i + 1; j < timeline.length; j++) {
            let hour = parseInt(timeline[j]["hour"].split(":")[0]);
            if (currentHour === hour && deviceId === timeline[j]["deviceId"]) {
              let keys = currentChecker["keys"];
              currentChecker[keys[0]] =
                currentChecker[keys[0]] + timeline[j][keys[0]];
              currentChecker[keys[1]] =
                currentChecker[keys[1]] + timeline[j][keys[1]];
              currentChecker["total"] =
                currentChecker["total"] + timeline[j]["total"];
              map.set(currentHour, currentChecker);
            }
          }
          temp.push(currentChecker);
        }
      }
    }
  }
  return temp;
}

function fillLine(timeline) {
  let temp = [];
  let devices = [
    ...new Set(
      timeline.map((obj) => {
        return obj.deviceId;
      })
    ),
  ];
  // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
  for (let j = 0; j < devices.length; j++) {
    const device = devices[j];
    for (let i = 0; i < new Date().getHours(); i++) {
      let hour = i < 10 ? `0${i}:00` : `${i}:00`;
      let res = findHourData(timeline, hour, device);
      if (res.success !== -1) {
        temp.push(res.timeline);
      } else {
        let obj = {
          hour: hour,
          deviceId: device,
          keys: res.timeline["keys"],
          total: 0,
        };
        for (let l = 0; l < res.timeline["keys"].length; l++) {
          const element = res.timeline["keys"][l];
          obj[element] = 0;
        }
        temp.push(obj);
      }
    }
  }
  return temp;
}
function removeDuplications(timeline) {
  let map = new Map();
  for (let i = 0; i < timeline.length; i++) {
    const time = timeline[i];
    let key = time["deviceId"] + time["hour"];
    if (map.size === 0) {
      map.set(key, time);
    } else if (!map.get(key)) {
      map.set(key, time);
    } else continue;
  }
  return [...map.values()];
}
function isObjEqual(a, b) {
  var _ = require("lodash");
  return _.isEqual(a, b);
}
var request_updateTimelineData_safe = true;
var request_updateGouge_safe = true;
var request_updateTrackObjects_safe = true;

const AtidimCombinedComponents = ({ token, areas, map }) => {
  const [rest_trackObj, setRest_trackObj] = useState({});

  const [timelineData, setTimelineData] = useState([]);
  const [totalCountVehicles, setTotalCountVehicles] = useState(0);
  const [totalWeekAgo, setTotalWeekAgo] = useState(0);
  const [rootLocations, setRootLocations] = useState([]);
  const [polygons, setPoylgons] = useState([]);
  const [loadingGouge, setLoadingGouge] = useState(true);
  const [loadingChart, setLoadingChart] = useState(true);
  const [deviceVelocity, setdeviceVelocity] = useState([]);
  const [deviceKeys, setDeviceKeys] = useState([]);
  const [devicesNames, setdevicesNames] = useState([]);
  const [pie, setPie] = useState(new Map());
  const [types, setTypes] = useState([]);
  const colors = [
    ["#1AFF1A", "#4B0092"],
    ["#FFC20A", "#0C7BDC"],
    ["#FEFE62", "#D35FB7"],
  ];
  const colorTexts = [
    ["text-blue-700", "text-indigo-700"],
    ["text-purple-700", "text-purple-400"],
    "text-green-700",
  ];
  const textDescription = ["Entering", "Leaving"];
  const textChartDescription = ["North Entrance", "South Entrance"];
  function getDeviceNames() {
    let map = new Map();
    let rootLocations = new Map();
    let polygons = new Map();
    Array.from(areas).forEach((area) => {
      Array.from(area.devices).forEach((device) => {
        rootLocations.set(device.deviceId, device.rootLocation);
        polygons.set(device.deviceId, device.polygon);
        map.set(device.deviceId, device.name);
      });
    });
    setdevicesNames((prev) => [...map.keys()].reverse());
    setDeviceKeys((prev) => [...map.keys()].reverse());
    setRootLocations((prev) => [...rootLocations.values()].reverse());
    setPoylgons((prev) => [...polygons.values()].reverse());
  }

  function updateGougeData() {
    if (request_updateGouge_safe === false) {
      return;
    } else {
      request_updateGouge_safe = false;
    }

    axios
      .get(`/v1/realtime/eilat/velocity/minutes?token=${token}&areas=null`)
      .then((res) => {
        let map = new Map();

        for (let i = 0; i < res.data.length; i++) {
          let velocity = res.data[i].velocity;
          let timestamp = res.data[i].timestamp;
          if (checkIfXSecPass(timestamp, 20))
            if (velocity) {
              map.set(res.data[i]["sensor"], velocity);
            } else {
              map.set(res.data[i]["sensor"], 0);
            }
          else {
            map.set(res.data[i]["sensor"], 0);
          }
        }
        setDeviceKeys((prev) => [...map.keys()].reverse());
        setdeviceVelocity((prev) => [...map.values()].reverse());
        setdevicesNames((prev) => [...map.keys()].reverse());
        setLoadingGouge(false);
        request_updateGouge_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
        request_updateGouge_safe = true;
      });
  }

  function updateTimelineData() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(
        `/v1/statistics/hour?token=${token}&day=${new Date().getUTCDate()}&month=${
          new Date().getUTCMonth() + 1
        }&areas=${null}`
      )
      .then((res) => {
        let resData = [];
        let totalVehicles = 0;
        let mapPie = new Map();
        let devices = [
          ...new Set(
            res.data
              .map((value) => {
                return value
                  .map((val) => {
                    return val["deviceId"];
                  })
                  .flat();
              })
              .flat()
          ),
        ];
        for (let i = 0; i < devices.length; i++) {
          const element = devices[i];
          mapPie.set(element, []);
        }
        let dimXY = res.data.map((values) => {
          return values.map((val) => {
            let device = val["deviceId"];
            let arr = mapPie.get(device);
            let dimXY = val["dimXY"]
              .map((arg) => {
                return arg["Type"];
              })
              .flat();
            arr = arr.concat(dimXY);
            mapPie.set(val["deviceId"], arr);
            return dimXY.flat();
          });
        });
        dimXY = dimXY.flat();
        let types = [...new Set(dimXY.flat())];
        setTypes((prev) => types);
        setPie((prev) => mapPie);
        // console.log(res.data);
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
            if (
              new Date(res.data[i][j]["date"]).getHours() <
              new Date().getHours()
            ) {
              let entering = res.data[i][j]["dimXY"].filter((val) => {
                return val["velY"] < 0;
              }).length;
              let leaving = res.data[i][j]["dimXY"].filter((val) => {
                return val["velY"] > 0;
              }).length;
              let objectCount = entering > leaving ? entering : leaving;
              let id = res.data[i][j]["deviceId"].slice(10);
              let keys = [`entering-${id}`, `leaving-${id}`];
              let obj = {
                hour: getLocalHour(res.data[i][j]["date"]),
                deviceId: res.data[i][j]["deviceId"],
                keys: keys,
                total: objectCount,
              };
              obj[keys[0]] = entering;
              obj[keys[1]] = leaving;
              resData.push(obj);
            }
            totalVehicles += res.data[i][j]["totalCount"];
          }
        }

        // TODO: need to check if this if needed
        // if (JSON.stringify(timelineData) !== JSON.stringify(resData)) {
        resData = margeSameHours(resData);
        resData = fillLine(resData);
        resData = removeDuplications(resData);
        setLoadingChart(false);
        //
        setTimelineData((prev) => resData);
        if (totalCountVehicles !== totalVehicles) {
          setTotalCountVehicles((prev) => totalVehicles);
        }
        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
        request_updateTimelineData_safe = true;
      });
  }

  function rest_updateTrackObjects() {
    // console.log("updating objects");
    if (request_updateTrackObjects_safe === false) {
      return;
    } else {
      request_updateTrackObjects_safe = false;
    }
    axios
      .get(
        `/v1/realtime/snapshotz?token=${token}`
        //  {
        //   withCredentials: true,
        // }
      )
      .then((res) => {
        let objs = [];
        let map = new Map();
        for (let d = 0; d < res.data.length; d++) {
          if (res.data[d] !== null && res.data[d]["objectsCount"] > 0) {
            let device_id = res.data[d]["sensor"];
            if (checkIfXSecPass(res.data[d]["timestamp"], 20)) {
              setRest_trackObj((prev) => [...objs]);
            } else {
              let objects = res.data[d]["objects"];
              objects = objects.filter((a) => a.speed > 0);
              for (let i = 0; i < objects.length; i++) {
                let id = device_id + " " + objects[i].id;
                map.set(id, device_id);
              }
              map.forEach((value, key) => objs.push({ deviceId: value }));
            }
          }
        }
        if (!isObjEqual(rest_trackObj, objs)) {
          setRest_trackObj((prev) => [...objs]);
        }
        request_updateTrackObjects_safe = true;
      })
      .catch((err) => {
        console.log("error with get data inside live map-> ", err);
        request_updateTrackObjects_safe = true;
      });
  }

  useEffect(() => {
    // setTimeout(() => {
    updateTimelineData();
    updateGougeData();
    getDeviceNames();
    rest_updateTrackObjects();
    // }, 200);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      updateGougeData();
      return () => {};
    },
    !loadingGouge ? 1000 : 5000,
    true
  );
  useInterval(
    () => {
      rest_updateTrackObjects();
      return () => {};
    },
    !loadingGouge ? 1000 : 5000,
    true
  );
  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      updateTimelineData();
      return () => {};
    },
    !loadingChart ? 1000 : 5000,
    true
  );

  if (loadingChart || loadingGouge) {
    return (
      <div className="flex justify-center">
        <div className="bg-gray-300  w-full px-4 h-100 rounded-md overflow-hidden transition-all">
          <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col h-full w-full justify-around ">
      {deviceVelocity.length > 0 &&
        Array.from(deviceVelocity).map(
          (value, index) => (
            <div
              key={deviceKeys.at(index)}
              className={`
             text-center flex flex-col  rounded-xl mt-2 bg-slate-50  `}
            >
              <div className=" text-center flex w-full h-full flex-col justify-items-center justify-center   ">
                <div className=" font-bold ">{textChartDescription[index]}</div>
                <div
                  className="flex flex-row items-center  justify-evenly"
                  key={index}
                >
                  <div
                    className="w-1/2  rounded-lg "
                    key={deviceKeys.at(index) + "1"}
                  >
                    <div>
                      <AtidimSvgComponent
                        key={deviceKeys.at(index) + index}
                        description={textDescription}
                        svgColor={colors[index]}
                        textColor={colorTexts[index]}
                      />
                    </div>
                    <div>
                      <AtidimChartComponent
                        key={deviceKeys.at(index) + index + index}
                        device={deviceKeys.at(index)}
                        data={timelineData}
                        colorGraph={colors[index]}
                        colorText={colorTexts[index]}
                        textDescription={textChartDescription[index]}
                      />
                    </div>
                  </div>
                  {types.length > 0 && (
                    <AtidimPieChart
                      device={deviceKeys.at(index)}
                      pieData={pie}
                      types={types}
                      colors={colors[index]}
                    />
                  )}
                  <GougeComponent key={deviceKeys.at(index)} speed={value} />
                  <AtidimMap
                    index={index}
                    device={deviceKeys.at(index)}
                    objects={rest_trackObj}
                    polygon={polygons[index]}
                    configToken={map.mapboxToken}
                    configStyle={map.style}
                    center={rootLocations[index]}
                    zoom={map.zoom}
                  />
                </div>
              </div>
            </div>
          ),
          [deviceVelocity, deviceKeys]
        )}
      {deviceVelocity.length === 0 && (
        <div
          className={`
         text-center rounded-2xl mx-10 `}
        >
          <div className="font-bold text-lg text-gray-600  ">
            No Sensor at Service
            {/* {console.log(deviceKeys.at(index))} */}
          </div>
          <div className="flex flex-col  self-center mx-10">
            <GougeComponent key={0} speed={0} />
          </div>
        </div>
      )}
    </div>
  );
};

export default AtidimCombinedComponents;
